import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import { logEvent } from 'utils/tracking';

export const logMarketingCampaignsEvent = ({ submodule, functionality, checkDuplicate = false }) =>
    logEvent({
        event: CAMPAIGNS_MARKETING.trueName,
        submodule,
        functionality,
        checkDuplicate,
    });
